import React from "react";
import { FaArrowRight } from "react-icons/fa";

const cardData = [
  {
    title: "Taste",
    desc: "Taste like – It is prepared by your mom. All recipes are prepared by our experienced chefs. ",
    img: "/images/whychooseus_logo1.png",
  },
  {
    title: "Pure Veg",
    desc: "You do not need to worry about that. For the last 8 years, we have maintained the same thing from the start.",
    img: "/images/whychooseus_logo2.png",
  },
  {
    title: "Open Area",
    desc: "You can sit in an open area with customized tables and stools. ",
    img: "/images/whychooseus_logo3.png",
  },
  {
    title: "Selfie Point",
    desc: "We are famous for our Rajasthani village theme for our restaurant",
    img: "/images/whychooseus_logo4.png",
  },
];

export default function WhyChooseUs() {
  return (
    <div className="py-16 px-4 md:px-10 bg-cream">
      <div className="text-center mb-12">
        <h5 className="text-primary-dark font-semibold uppercase tracking-widest text-sm mb-2">
          Why Second Home
        </h5>
        <h1 className="font-display text-4xl font-bold text-gray-800">Why Choose Us</h1>
      </div>
      <div className=" grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 justify-center gap-6 p-7 space-y-10 sm:space-y-0 sm:p-10">
        {cardData.map((item, index) => (
          <div
            key={index}
            className="bg-gradient-to-b from-[#0000000d] to-white rounded-[30px] sm:w-[280px] text-center p-6 rounded-b-none shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
          >
            <div className="w-[80px] h-[80px] shadow-[0_8px_30px_rgb(0,0,0,0.12)] mx-auto overflow-hidden rounded-full bg-white flex items-center justify-center -mt-16 mb-4">
              <img src={item.img} alt={item.title} className="w-14 h-14" />
            </div>
            <h1 className="text-[26px] font-medium text-black">{item.title}</h1>
            <p className="text-gray-500 text-[16px] mt-2">{item.desc}</p>
            <div className="mt-4 text-primary-dark font-semibold flex justify-center items-center gap-1 cursor-pointer">
              Learn More <FaArrowRight size={12} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
